export function getUser(state) {
   return state.user;
}
